import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import { ControllerDetails } from '#services/cve/ControllerDetails';
import { IterationStatusCode, LineOfBusiness, VettingIteration } from '#services/cve/VettingIteration';

export const archivedKycMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId$',
    },
    response: {
      status: 200,
      body: {
        iterationId: 'iterationId',
        lineOfBusiness: LineOfBusiness.TCI,
        companyId: '113',
        statusCode: IterationStatusCode.CANCELLED,
        creation: {
          creationDateTime: '2024-04-19T10:05:42.156Z',
          creatorId: 'CVE',
          ownerId: 'CVE',
        },
        closure: {
          closureDateTime: '2024-04-19T10:05:42.156Z',
          requestorId: 'CVE',
        },
        controls: [
          {
            controlCode: 'CompanyGrade',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'EconomicSanctions',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'SensitiveBusiness',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'SensitiveCountry',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'EnergyPolicy',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'PoliticalExposedPerson',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'Gerl',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'ReputationalRisk',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'CompanyConsortOrCoop',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'AccountOwner',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'AccountDetails',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'BuExchangeGroup',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'MncList',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'PreviousContract',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'PreviousNegociation',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'ProspectLocation',
            statusCode: ControllerStatus.NOT_STARTED,
          },
          {
            controlCode: 'UnpaidPremiumAndFees',
            statusCode: ControllerStatus.NOT_STARTED,
          },
        ] satisfies ControllerDetails[],
        customProperties: {},
      } satisfies VettingIteration,
    },
  },
];
